import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useCategories } from "~/api/swr/useCategories";
import { CategoryModal } from "~/organisms/CategoryModal";
import { ReorderCategoryModal } from "~/organisms/ReorderCategoryModal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from "~/atoms/dropdown-menu";

export function ManageCategoriesButton() {
  const { t } = useTranslation();
  const { data: categories } = useCategories();

  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          {t("commons.buttons.manage")} {t("commons.document.categories")}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuGroup className="space-y-2 px-1 py-2">
          <CategoryModal
            onClosePopover={() => setOpen(false)}
            trigger={
              <Button className="w-full" variant="secondary">
                {t("commons.buttons.create")} {t("commons.document.category")}
              </Button>
            }
          />
          <ReorderCategoryModal
            categories={categories ?? []}
            onClosePopover={() => setOpen(false)}
            trigger={
              <Button className="w-full" variant="secondary">
                {t("commons.buttons.reorder")}{" "}
                {t("commons.document.categories")}
              </Button>
            }
          />
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
